import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PrivateRoute from '../auth/PrivateRoute';
import Login from '../auth/Auth';
import BusinessLandingPage from '../pages/businessLandingPage/LandingPage';
import CostumerLandingPage from '../pages/costumerLandingPage/LandingPage';
import ExcluirContaUsuario from '../pages/businessLandingPage/ExcluirContaUsuario';
import Dashboard from '../pages/dashboard/Dashboard';
import VendasEmAndamento from '../pages/vendas/VendasEmAndamento';
import VendasCanceladas from '../pages/vendas/VendasCanceladas';
import VendasEntregues from '../pages/vendas/VendasEntregues';
import Produtos from '../pages/produto/Produto';
import ProdutoCadastro from '../pages/produto/ProdutoCadastro';
import UploadImagensProduto from '../pages/produto/ProdutoUploadImagens';
import ProdutoVideoUpload from '../pages/produto/ProdutoVideoUpload';
import Categoria from '../pages/categoria/Categoria';
import CategoriaCadastro from '../pages/categoria/CategoriaCadastro';
import Negocio from '../pages/negocio/Negocios';
import NegocioCadastro from '../pages/negocio/NegocioCadastro';
import MeuNegocioCadastro from '../pages/negocio/NegocioConsulta';
import Enderecos from '../pages/endereco/Enderecos';
import EnderecoCadastro from '../pages/endereco/EnderecoCadastro';
import Funcionarios from '../pages/funcionario/Funcionarios';
import FuncionariosDoNegocio from '../pages/funcionario/FuncionariosDoNegocio';
import FuncionarioCadastro from '../pages/funcionario/FuncionarioCadastro';
import FuncionarioEditar from '../pages/funcionario/FuncionarioEditar';
import Perguntas from '../pages/perguntas/Perguntas';
import TermosDeUso from '../pages/businessLandingPage/TermosDeUso';
import PoliticasDePrivacidade from '../pages/businessLandingPage/PoliticasDePrivacidade';
import NegocioUploadLogo from '../pages/negocio/NegocioUploadLogo';
import DetalharVenda from '../pages/vendas/DetalharVenda';
import SucessoStripeOnboarding from '../pages/negocio/SucessoStripeOnboarding';
import RegerarUrlStripeOnboard from '../pages/negocio/RegerarUrlStripeOnboard';
import Campanhas from '../pages/publicidade/Campanhas';
import CadastrarCampanha from '../pages/publicidade/CadastrarCampanha';
import ConfiguracoesDoNegocio from '../pages/negocio/Configuracoes';
import Usuarios from '../pages/usuarios/Usuarios';
import OnboardingStripeRedirect from '../pages/negocio/OnboardingStripeRedirect';
import VersaoApp from '../pages/versaoApp/Versoes';
import VersaoCadastro from '../pages/versaoApp/VersaoCadastro';
import CupomDeDescontoCadastro from '../pages/cupomDesconto/Cadastro';
import CupomDeDescontoLista from '../pages/cupomDesconto/Lista';
import Vendas from '../pages/vendas/Vendas';
import ProdutoLanding from '../pages/produto/ProdutoLanding';
import NegocioLanding from '../pages/negocio/NegocioLanding';
import Repasses from '../pages/repasses/Repasses';
import DetalheRepasse from '../pages/repasses/DetalheRepasse';
import Notificacoes from '../pages/notificacoesPush/Notificacoes';
import NotificacoesPushCadastro from '../pages/notificacoesPush/Cadastro';
import Fretes from '../pages/frete/Fretes';

const Routes = () => (
    <Switch>
        <Route path='/' exact component={CostumerLandingPage} />
        <Route path='/lojista' exact component={BusinessLandingPage} />
        <Route path='/produto/:id' exact component={ProdutoLanding} />
        <Route path='/loja/:id' exact component={NegocioLanding} />
        <Route path='/excluir-minha-conta' exact component={ExcluirContaUsuario} />
        <Route path='/termos-de-uso' exact component={TermosDeUso} />
        <Route path='/politicas-de-privacidade' exact component={PoliticasDePrivacidade} />
        <Route path='/onboarding-stripe-redirect/:idNegocio' exact component={OnboardingStripeRedirect} />
        <Route path="/login" exact component={Login} />
        <PrivateRoute path='/dashboard' exact component={Dashboard} />
        <PrivateRoute path='/vendas' exact component={Vendas} />
        <PrivateRoute path='/vendas-em-andamento' exact component={VendasEmAndamento} />
        <PrivateRoute path='/vendas-canceladas' exact component={VendasCanceladas} />
        <PrivateRoute path='/vendas-entregues' exact component={VendasEntregues} />
        <PrivateRoute path='/detalhar-venda' exact component={DetalharVenda} />
        <PrivateRoute path='/produtos' exact component={Produtos} />
        <PrivateRoute path='/produtos/cadastrar-produto' exact component={ProdutoCadastro} />
        <PrivateRoute path='/produtos/editar-produto' exact component={ProdutoCadastro} />
        <PrivateRoute path='/produtos/imagens-do-produto' exact component={UploadImagensProduto} />
        <PrivateRoute path='/produtos/video-do-produto' exact component={ProdutoVideoUpload} />
        <PrivateRoute path='/categorias' exact component={Categoria} />
        <PrivateRoute path='/categorias/cadastrar-categoria' exact component={CategoriaCadastro} />
        <PrivateRoute path='/categorias/editar-categoria' exact component={CategoriaCadastro} />
        <PrivateRoute path='/lojas' exact component={Negocio} />
        <PrivateRoute path='/lojas/cadastrar-loja' exact component={NegocioCadastro} />
        <PrivateRoute path='/lojas/editar-loja' exact component={NegocioCadastro} />
        <PrivateRoute path='/lojas/logo-da-loja' exact component={NegocioUploadLogo} />
        <PrivateRoute path='/notificacoes-push' exact component={Notificacoes} />
        <PrivateRoute path='/notificacoes-push/cadastrar-notificacao' exact component={NotificacoesPushCadastro} />
        <PrivateRoute path='/notificacoes-push/detalhar-notificacao' exact component={NotificacoesPushCadastro} />
        <PrivateRoute path='/enderecos/:origem/:idOrigem' exact component={Enderecos} />
        <PrivateRoute path='/enderecos/cadastrar-endereco/:origem/:idOrigem' exact component={EnderecoCadastro} />
        <PrivateRoute path='/enderecos/editar-endereco-funcionario/:origem/:idOrigem/:idEndereco' exact component={EnderecoCadastro} />
        <PrivateRoute path='/meu-negocio' exact component={MeuNegocioCadastro} />
        <PrivateRoute path='/funcionarios' exact component={Funcionarios} />
        <PrivateRoute path='/funcionarios-da-loja' exact component={FuncionariosDoNegocio} />
        <PrivateRoute path='/funcionarios-da-loja/cadastrar-funcionario' exact component={FuncionarioCadastro} />
        <PrivateRoute path='/funcionarios-da-loja/editar-funcionario' exact component={FuncionarioEditar} />
        <PrivateRoute path='/configuracoes' exact component={ConfiguracoesDoNegocio} />
        <PrivateRoute path='/perguntas-e-respostas' exact component={Perguntas} />
        <PrivateRoute path='/sucesso-stripe-onboarding' exact component={SucessoStripeOnboarding} />
        <PrivateRoute path='/re-stripe-onboarding' exact component={RegerarUrlStripeOnboard} />
        <PrivateRoute path='/campanhas-publicitarias-no-app' exact component={Campanhas} />
        <PrivateRoute path='/campanhas-publicitarias-no-app/cadastrar-campanha' exact component={CadastrarCampanha} />
        <PrivateRoute path='/campanhas-publicitarias-no-app/editar-campanha' exact component={CadastrarCampanha} />
        <PrivateRoute path='/campanhas-publicitarias-no-app/visualizar-campanha' exact component={CadastrarCampanha} />
        <PrivateRoute path='/usuarios' exact component={Usuarios} />
        <PrivateRoute path='/versoes-app' exact component={VersaoApp} />
        <PrivateRoute path='/versoes-app/cadastrar-versao' exact component={VersaoCadastro} />
        <PrivateRoute path='/versoes-app/editar-versao' exact component={VersaoCadastro} />
        <PrivateRoute path='/cupom-de-desconto/cadastrar-cupom' exact component={CupomDeDescontoCadastro} />
        <PrivateRoute path='/cupom-de-desconto/editar-cupom' exact component={CupomDeDescontoCadastro} />
        <PrivateRoute path='/cupom-de-desconto/detalhar-cupom' exact component={CupomDeDescontoCadastro} />
        <PrivateRoute path='/cupom-de-desconto' exact component={CupomDeDescontoLista} />
        <PrivateRoute path='/repasses-ao-vendedor' exact component={Repasses} />
        <PrivateRoute path='/repasses-ao-vendedor/detalhar-repasse' exact component={DetalheRepasse} />
        <PrivateRoute path='/melhor-envio' exact component={Fretes} />
        <Redirect to='/' from='*' />
    </Switch>
)

export default Routes;